export default function ShareFacebook() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3688 25.6667H15.6417V15.0208H19.2146L19.7542 10.8792H15.6417V8.225C15.6417 7.02916 15.9771 6.21249 17.6979 6.21249H19.9V2.49374C19.5208 2.44999 18.2229 2.33333 16.7063 2.33333C13.5271 2.33333 11.3688 4.27291 11.3688 7.81666V10.8792H7.78125V15.0208H11.3688V25.6667Z"
        fill="#222424"
      />
    </svg>
  );
}
